var map = {
	"./background_dark.png": 895,
	"./background_light.png": 5504,
	"./characters/baby_daisy.png": 7049,
	"./characters/baby_luigi.png": 8230,
	"./characters/baby_mario.png": 9303,
	"./characters/baby_peach.png": 9349,
	"./characters/baby_rosalina.png": 1940,
	"./characters/birdo.png": 9214,
	"./characters/black_birdo.png": 6740,
	"./characters/black_shy_guy.png": 5019,
	"./characters/black_yoshi.png": 2436,
	"./characters/blue_birdo.png": 9583,
	"./characters/blue_shy_guy.png": 398,
	"./characters/blue_yoshi.png": 4556,
	"./characters/bowser.png": 9313,
	"./characters/bowser_jr.png": 6548,
	"./characters/cat_peach.png": 7379,
	"./characters/champion_link.png": 8795,
	"./characters/daisy.png": 8599,
	"./characters/diddy_kong.png": 7809,
	"./characters/donkey_kong.png": 4721,
	"./characters/dry_bones.png": 9297,
	"./characters/dry_bowser.png": 5106,
	"./characters/female_villager.png": 7819,
	"./characters/funky_kong.png": 8601,
	"./characters/gold_mario.png": 5451,
	"./characters/green_birdo.png": 8060,
	"./characters/green_shy_guy.png": 6773,
	"./characters/iggy.png": 2506,
	"./characters/inkling_boy.png": 3741,
	"./characters/inkling_girl.png": 3746,
	"./characters/isabelle.png": 2159,
	"./characters/kamek.png": 2915,
	"./characters/king_boo.png": 6261,
	"./characters/koopa_troopa.png": 3787,
	"./characters/lakitu.png": 1070,
	"./characters/larry.png": 6986,
	"./characters/lemmy.png": 2588,
	"./characters/light_blue_birdo.png": 8041,
	"./characters/light_blue_shy_guy.png": 1015,
	"./characters/light_blue_yoshi.png": 5268,
	"./characters/lime_green_inkling_girl.png": 3553,
	"./characters/link.png": 5514,
	"./characters/ludwig.png": 5465,
	"./characters/luigi.png": 2392,
	"./characters/magenta_inkling_girl.png": 619,
	"./characters/male_villager.png": 129,
	"./characters/mario.png": 3436,
	"./characters/metal_mario.png": 7152,
	"./characters/mii.png": 1753,
	"./characters/morton.png": 3518,
	"./characters/orange_birdo.png": 8354,
	"./characters/orange_shy_guy.png": 4202,
	"./characters/orange_yoshi.png": 3099,
	"./characters/pauline.png": 777,
	"./characters/peach.png": 5879,
	"./characters/peachette.png": 3582,
	"./characters/petey_piranha.png": 992,
	"./characters/pink_gold_peach.png": 6734,
	"./characters/pink_shy_guy.png": 5891,
	"./characters/pink_yoshi.png": 3392,
	"./characters/purple_inkling_boy.png": 5612,
	"./characters/red_birdo.png": 3064,
	"./characters/red_yoshi.png": 2659,
	"./characters/rosalina.png": 2465,
	"./characters/roy.png": 5415,
	"./characters/shy_guy.png": 3197,
	"./characters/tanooki_mario.png": 5453,
	"./characters/teal_inkling_boy.png": 2819,
	"./characters/toad.png": 2687,
	"./characters/toadette.png": 1216,
	"./characters/waluigi.png": 1448,
	"./characters/wario.png": 6079,
	"./characters/wendy.png": 3851,
	"./characters/white_birdo.png": 1416,
	"./characters/white_shy_guy.png": 1839,
	"./characters/white_yoshi.png": 3224,
	"./characters/wiggler.png": 3019,
	"./characters/yellow_birdo.png": 8177,
	"./characters/yellow_shy_guy.png": 6558,
	"./characters/yellow_yoshi.png": 1744,
	"./characters/yoshi.png": 1588,
	"./cups/acorn.png": 8825,
	"./cups/banana.png": 2906,
	"./cups/bell.png": 4231,
	"./cups/boomerang.png": 8455,
	"./cups/cherry.png": 8557,
	"./cups/crossing.png": 2200,
	"./cups/egg.png": 5456,
	"./cups/feather.png": 5646,
	"./cups/flower.png": 2605,
	"./cups/fruit.png": 5143,
	"./cups/golden_dash.png": 9182,
	"./cups/leaf.png": 7772,
	"./cups/lightning.png": 4327,
	"./cups/lucky_cat.png": 513,
	"./cups/moon.png": 5626,
	"./cups/mushroom.png": 325,
	"./cups/propeller.png": 9308,
	"./cups/rock.png": 6452,
	"./cups/shell.png": 6005,
	"./cups/special.png": 5847,
	"./cups/spiny.png": 9398,
	"./cups/star.png": 4551,
	"./cups/triforce.png": 5805,
	"./cups/turnip.png": 1415,
	"./dk_wheel.gif": 8305,
	"./flags/1WWD.svg": 6794,
	"./flags/2ABB.svg": 1279,
	"./flags/2ATA.svg": 8437,
	"./flags/2EEE.svg": 3832,
	"./flags/2FFF.svg": 775,
	"./flags/2NNN.svg": 4701,
	"./flags/2SRR.svg": 1437,
	"./flags/2UUU.svg": 1249,
	"./flags/9DAC.svg": 3607,
	"./flags/9EUR.svg": 8080,
	"./gliders/bowser_kite.png": 5393,
	"./gliders/cloud_glider.png": 1112,
	"./gliders/flower_glider.png": 6961,
	"./gliders/gold_glider.png": 8212,
	"./gliders/hylian_kite.png": 6406,
	"./gliders/mktv_parafoil.png": 4952,
	"./gliders/paper_glider.png": 2526,
	"./gliders/parachute.png": 6640,
	"./gliders/parafoil.png": 2151,
	"./gliders/paraglider.png": 9614,
	"./gliders/peach_parasol.png": 9572,
	"./gliders/plane_glider.png": 4589,
	"./gliders/super_glider.png": 2039,
	"./gliders/waddle_wing.png": 5808,
	"./gliders/wario_wing.png": 2342,
	"./item_box.png": 366,
	"./items/coin.png": 3012,
	"./items/mushroom.png": 8759,
	"./laps/lap1.svg": 4189,
	"./laps/lap2.svg": 6761,
	"./laps/lap3.svg": 2961,
	"./laps/lap4.svg": 4637,
	"./laps/lap5.svg": 1860,
	"./laps/lap6.svg": 5164,
	"./laps/lap7.svg": 4319,
	"./mario_sleep.gif": 8575,
	"./mk8_logo.png": 2178,
	"./mk8_logo_full.png": 3453,
	"./mk8dx_logo.png": 2371,
	"./mk8dx_logo_full.png": 9425,
	"./tires/ancient_tires.png": 8830,
	"./tires/azure_roller.png": 5848,
	"./tires/blue_standard.png": 2186,
	"./tires/button.png": 177,
	"./tires/crimson_slim.png": 6192,
	"./tires/cushion.png": 8470,
	"./tires/cyber_slick.png": 4941,
	"./tires/gla_tires.png": 2638,
	"./tires/gold_tires.png": 6472,
	"./tires/hot_monster.png": 6629,
	"./tires/leaf_tires.png": 2401,
	"./tires/metal.png": 2098,
	"./tires/monster.png": 7163,
	"./tires/off_road.png": 9367,
	"./tires/retro_off_road.png": 6451,
	"./tires/roller.png": 471,
	"./tires/slick.png": 5108,
	"./tires/slim.png": 4934,
	"./tires/sponge.png": 5689,
	"./tires/standard.png": 481,
	"./tires/triforce_tires.png": 4732,
	"./tires/wood.png": 2842,
	"./vehicles/300_sl_roadster.png": 6108,
	"./vehicles/b_dasher.png": 3795,
	"./vehicles/badwagon.png": 3677,
	"./vehicles/biddybuggy.png": 8991,
	"./vehicles/blue_falcon.png": 7926,
	"./vehicles/bone_rattler.png": 5135,
	"./vehicles/cat_cruiser.png": 8311,
	"./vehicles/circuit_special.png": 7172,
	"./vehicles/city_tripper.png": 1551,
	"./vehicles/comet.png": 2338,
	"./vehicles/flame_rider.png": 1606,
	"./vehicles/gla.png": 8443,
	"./vehicles/gold_standard.png": 7249,
	"./vehicles/inkstriker.png": 5298,
	"./vehicles/jet_bike.png": 7965,
	"./vehicles/koopa_clown.png": 1612,
	"./vehicles/landship.png": 9644,
	"./vehicles/mach_8.png": 8664,
	"./vehicles/master_cycle.png": 2831,
	"./vehicles/master_cycle_zero.png": 2780,
	"./vehicles/mr_scooty.png": 4252,
	"./vehicles/p_wing.png": 3910,
	"./vehicles/pipe_frame.png": 8453,
	"./vehicles/prancer.png": 6672,
	"./vehicles/sneeker.png": 1929,
	"./vehicles/splat_buggy.png": 3405,
	"./vehicles/sport_bike.png": 7669,
	"./vehicles/sports_coupe.png": 4045,
	"./vehicles/standard_atv.png": 3387,
	"./vehicles/standard_bike.png": 7812,
	"./vehicles/standard_kart.png": 7780,
	"./vehicles/steel_driver.png": 8528,
	"./vehicles/streetle.png": 3118,
	"./vehicles/tanooki_kart.png": 2442,
	"./vehicles/teddy_buggy.png": 4288,
	"./vehicles/the_duke.png": 2063,
	"./vehicles/tri_speeder.png": 4214,
	"./vehicles/varmint.png": 5078,
	"./vehicles/w_25_silver_arrow.png": 4450,
	"./vehicles/wild_wiggler.png": 7704,
	"./vehicles/yoshi_bike.png": 7524,
	"./wheel.png": 7972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;